import { ICreateChat, ICreateChatMessage, 
  IInviteMember, IRequestChatMessages, IToxicCheck, IChatAlteration, 
  ICreateChatMessageAction, IRequestMessageReadInfo, IChatCheckIn} from '@app-types/websocket/chat.types';
import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

export function createChat(data: ICreateChat) {
  socket.sendJSON({
    newChat: data,
  });
}

export function createChatMessage(data: ICreateChatMessage) {
  socket.sendJSON({
    newChatMessage: data,
  });
}

export function createChatMessageToxicChecked(data: ICreateChatMessage) {
  socket.sendJSON({
    newChatMessageToxicCheck: data,
  });
}

export function saveChat(chatId: number) {
  socket.sendJSON({
    saveChat: chatId,
  });
}

export function createChatMessageToxicCheckedAction(data: ICreateChatMessageAction) {
  socket.sendJSON({
    toxicAction: data,
  });
}

export function chatCheckIn(data: IChatCheckIn) {
  socket.sendJSON({
    chatCheckIn: data,
  });
}

export function toxicCheck(data: IToxicCheck) {
  socket.sendJSON({
    toxicCheck: data,
  });
}

export function inviteMember(data: IInviteMember) {
  socket.sendJSON({
    inviteParent: data,
  });
}

export function requestChatMessages(data: IRequestChatMessages, requestId?: string) {
  socket.sendJSON(requestId ? {
    requestId,
    requestChatMessages: data
  } : {
    requestChatMessages: data
  });
}

export function chatReadReceipt(chatId: number) {
  socket.sendJSON({
    chatReadReceipt: { 
      chatId
    }
  });
}

export function requestMessageReadInfo(data: IRequestMessageReadInfo) {
  const requestId = `MESSAGE_READ_INFO:${data.chatId}:${data.msgId}:${Date.now()}`;
  socket.sendJSON({
    requestId,
    requestMessageReadInfo: data
  });
}

export function archiveChat(chatId: number) {
  socket.sendJSON({
    archiveChat: chatId
  });
}

export function renameChat(data: IChatAlteration) {
  socket.sendJSON({
    chatAlteration: data
  });
}



// WEBPACK FOOTER //
// ./src/services/chat/chat.websocket.ts